<template>
  <b-list-group>
    <b-list-group-item @click="handleItemClick" class="tree-node-item" :class="{ 'expanded': node.expanded }">
      <img v-if="node.type === 'grandparent'" :src="node.imageSrc" alt="Gestión" class="node-image" />
      <img v-else-if="node.type === 'parent'" :src="node.digitalizado ? node.imageSrcEn : node.imageSrcDi" alt="Caja" class="node-image" />
      <img v-else-if="node.type === 'child'" :src="node.digitalizado ? 'img/folder.svg' : 'img/folder_disabled.svg'" alt="Carpeta" class="node-image" />
      <b>{{ node.text }}</b>
    </b-list-group-item>
    <b-collapse v-model="node.expanded">
      <div v-if="node.children" class="children-container">
        <tree-node v-for="child in node.children" :key="child.id" :node="child" @child-click="handleChildClick"/>
      </div>
    </b-collapse>
  </b-list-group>
</template>

<script>
export default {
  props: ['node'],
  methods: {
    handleItemClick() {
      if (this.node.type === 'child') {
        this.$emit('child-click', this.node.id);
      }

      this.$set(this.node, 'expanded', !this.node.expanded);

      if (this.node.type === 'parent') {
        this.node.imageSrcEn = this.node.expanded ? 'img/box-open.png' : 'img/box.png';
      }
    },

    handleChildClick(childId) {
      // Evitar la acción si el child no está activo
      const childNode = this.node.children.find(child => child.id === childId);
      if (childNode && !childNode.digitalizado) {
        return;
      }

      this.$emit('child-click', childId);
    },
  },
  components: {
    TreeNode: () => import('./TreeNode.vue'),
  },
};
</script>

<style scoped>
.tree-node-item {
  border: none; /* Elimina los bordes */
  padding-left: 20px; /* Agrega un poco de espacio a la izquierda para representar jerarquía */
  cursor: pointer; /* Cambia el cursor a una mano */
  transition: box-shadow 0.3s; /* Añade transición a la sombra */
  position: relative; /* Añade posición relativa para el z-index */
  z-index: 1; /* Establece el z-index para evitar que las sombras se superpongan a los elementos debajo */
  display: flex; /* Usa flexbox para alinear elementos horizontalmente */
  align-items: center; /* Centra verticalmente los elementos en el contenedor */
}

.node-image {
  width: 20px; /* Tamaño de la imagen */
  height: 20px;
  margin-right: 10px; /* Espaciado entre la imagen y el texto */
}

.tree-node-item:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Añade sombra al pasar el ratón */
  z-index: 2; /* Aumenta el z-index al pasar el ratón para que esté por encima de otros elementos */
}

.children-container {
  margin-left: 20px; /* Añade espacio a la izquierda para los nodos hijos */
}
</style>
